// Oneness URLs for Partner Center Enrollment and Vetting
const partnerCenterOnenessBaseUrl =
  process.env.DEPLOYMENT_ENV === "production"
    ? "https://1s.microsoft.com"
    : "https://1s.microsoft-int.com";

export const partnerCenterEnrollmentApi = `${partnerCenterOnenessBaseUrl}/api/v1/enrollment/appdev`;

export const getPartnerCenterEnrollmentWorkflowApi = (referenceId: string) =>
  `${partnerCenterOnenessBaseUrl}/api/v1/enrollment/${referenceId}/status`;

export const partnerCenterGetAccountApi = `${partnerCenterOnenessBaseUrl}/api/v1/accounts`;

export const getPartnerCenterVettingStatusApi = (oneVetId: string) =>
  `${partnerCenterOnenessBaseUrl}/api/v1/registration/${oneVetId}`;

export const partnerCenterFileUploadApi = `${partnerCenterOnenessBaseUrl}/api/v1/fileupload`;

export const signUpUrl = "https://signup.live.com/signup";

// AMS URLs for Account and Roles lookups
const partnerCenterAmsBaseUrl = "https://accountmgmtservice.dce.mp.microsoft.com";

export const getPartnerCenterProgramsBySellerIdApi = (sellerId: string) =>
  `${partnerCenterAmsBaseUrl}/accounts/${sellerId}/programs`;

export const getAllPartnerCenterSellersByEmailApi = (email: string) =>
  // For some reason this API with this filter returns the list of all sellers BUT the roles and permissions lists are empty
  `${partnerCenterAmsBaseUrl}/accounts?filter.userPrincipalName=${email}`;

export const getPartnerCenterSellerDetailsBySellerIdApi = (sellerId: string) =>
  // This API returns the details of a specific seller including the roles and permissions
  `${partnerCenterAmsBaseUrl}/accounts/${sellerId}`;

export const getPartnerCenterRolesBySelledIdApi = (sellerId: string) =>
  `${partnerCenterAmsBaseUrl}/accounts/${sellerId}/roles`;

export const getPartnerCenterAccountsByOwnerEmailApi = (email: string) =>
  `${partnerCenterAmsBaseUrl}/accounts?filter.ownerEmail=${email}`;

export const getPartnerCenterAccountByStudioNameUri = (studioName: string) =>
  `${partnerCenterAmsBaseUrl}/accounts?filter.Publisher=${studioName}`;

export const getPartnerCenterPublisherNameAvailabilityUri = (studioName: string) =>
  `${partnerCenterAmsBaseUrl}/globalresources/publishernameavailability?name=${studioName}`;
